<template>
  <div>
    <div v-if="full" style="margin-bottom: 1rem; color: red">商品可以为培训机构的课程,课时,余额,或者是消耗性的次卡,比如(英语启蒙班-课时)(舞蹈进阶版-次卡)(储值卡-金额)等等</div>
    <el-form inline :model="searchForm" :loading="searching">
      <el-form-item label="名称">
        <el-input placeholder="多个可以用逗号分割" v-model="searchForm.titles">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="searchForm.remarks" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row v-if="full">
      <el-button icon="el-icon-plus" @click="addSku">新增商品</el-button>
      <el-button icon="el-icon-delete" @click="deleteItems">批量删除</el-button>
<!--      <el-button icon="el-icon-document-add">导入</el-button>-->
<!--      <el-button icon="el-icon-document-remove">导出</el-button>-->
    </el-row>
    <el-table :data="list" style="margin-top: 1rem" border
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="600"
              ref="tableView"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4"
                       :type="item.type === 2?'selection':''"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type === 4"
      >
        <template slot-scope="scope">
          <el-row style="margin-top: 10px" v-for="(actionItem, actionIndex) in scope.row[item.key]" :key="'btn_' + actionIndex">
            <el-tag size="medium" >
              {{actionItem[item.tagValueKey]}}
            </el-tag>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       fixed="right"
                       v-if="item.type === 3"
                       :type="item.type === 2?'selection':''"
      >
        <template slot-scope="scope">
          <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
            {{actionItem.title}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
    <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
      <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
        <el-tag v-for="(tag, index) in tags" :key="index" closable style="margin: 0.2rem">
          {{tag}}
        </el-tag>
        <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showEditSku" :title="editSkuTitle" width="50%">
      <add-sku :data="sku" @success="skuAddOrEditSuccess" @close="closeAddOrEditSku"/>
    </el-dialog>
    <el-dialog :visible.sync="showRechargePage" title="充值" width="50%" :append-to-body="true">
      <sku-recharge @close="showRechargePage=false" :customer="customer" :sku="currentSku" @success="search"/>
    </el-dialog>
    <el-dialog :visible.sync="showConsumePage" title="消费" width="50%" :append-to-body="true">
      <sku-consume @close="showConsumePage=false" :customer="customer" :sku="currentSku" @success="search"/>
    </el-dialog>
  </div>
</template>

<script>
import {consume, deleteByIds, querySku} from './skuApi'
import {operationByPath} from '../employee/employeeApi'
import AddSku from './addSku'
import SkuRecharge from './skuRecharge'
import SkuConsume from './skuConsume'

export default {
  name: 'sku',
  components: {SkuConsume, SkuRecharge, AddSku},
  data () {
    return {
      searchForm: {
        curPage: 1,
        pageSize: 20,
        titles: '',
        remarks: ''
      },
      sku: {
        title: '',
        remark: ''
      },
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditSku: false,
      editSkuTitle: '新增商品',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: [],
      full: true,
      showRechargePage: false,
      showConsumePage: false,
      currentSku: null
    }
  },
  created () {
    this.full = this.mode !== 'recharge' && this.mode !== 'consume'
    this.searchForm.mode = this.mode
    this.search()
  },
  props: {
    mode () {
      return 'full'
    },
    customer () {
      return null
    }
  },
  watch: {
    mode (v) {
      this.full = v !== 'recharge' && v !== 'consume'
      this.searchForm.mode = v
      this.search()
    },
    customer (v) {
      this.search()
    }
  },
  methods: {
    search () {
      this.searching = true
      if (this.customer) {
        this.searchForm.customerId = this.customer.customerId
      } else {
        delete this.searchForm.customerId
      }
      querySku(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    reset () {
      this.searchForm.titles = ''
      this.searchForm.remarks = ''
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'phones'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
      this.multipleEditName = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    addSku () {
      this.sku = {
        title: '',
        remark: ''
      }
      this.editSkuTitle = '新增商品'
      this.showEditSku = true
    },
    skuAddOrEditSuccess () {
      this.showEditSku = false
      this.search()
    },
    closeAddOrEditSku () {
      this.showEditSku = false
    },
    deleteItems () {
      const items = this.$refs.tableView.selection
      if (items === undefined || items.length === 0) {
        this.$message.error('请选择需要删除的数据')
        return
      }
      const deleteAction = () => {
        const ids = []
        for (let i = 0; i < items.length; i++) {
          const tempItem = items[i]
          const {skuId} = tempItem
          ids.push(skuId)
        }
        deleteByIds({ids: ids}).then(rsp => {
          const {code, message} = rsp
          if (code === 0) {
            this.search()
            this.$message.success('操作成功')
          } else {
            this.$message.error(message)
          }
        })
      }
      this.$confirm('确定要删除这些商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(deleteAction).catch(null)
    },
    replaceText (text, item, encode) {
      const keys = Object.keys(item)
      for (let i = 0; i < keys.length; i++) {
        const tempKey = keys[i]
        const matchText = '{' + tempKey + '}'
        const index = text.indexOf(matchText)
        console.log(tempKey + ' ' + index + ' ' + matchText)
        if (index >= 0) {
          if (encode === true) {
            text = text.replace(matchText, encodeURIComponent(item[tempKey]))
          } else {
            text = text.replace(matchText, item[tempKey])
          }
        }
      }
      return text
    },
    quickConsume () {
      const item = {}
      item.count = 1
      item.customerId = this.customer.customerId
      item.skuId = this.currentSku.skuId
      consume(item).catch(null).then(rsp => {
        const { code } = rsp
        if (code === 0) {
          this.$message.success('消费成功')
          this.search()
        } else {
          const { message } = rsp
          this.$message.error(message)
        }
      })
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 0) {
        const { code } = action
        if (code === 'edit') {
          this.sku = item
          this.editSkuTitle = '编辑商品信息'
          this.showEditSku = true
        } else if (code === 'recharge') {
          this.currentSku = item
          this.showRechargePage = true
        } else if (code === 'consume') {
          this.currentSku = item
          this.showConsumePage = true
        } else if (code === 'one-consume') {
          this.$confirm('确定消费?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.currentSku = item
            this.quickConsume()
          }).catch(null)
        }
      } else if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sku/sku.vue